module.exports = __webpack_public_path__ + "static/media/tram.9af7cd62.svg";